import numeral from 'numeral';
import { formatDate } from '@shared/utils/date.utils';
import { formatAmount } from '@api/models/overview.model';

export const BET_SELECTION_MAPPING = {
    0: 'DRAW', 
    1: 'HOME',
    2: 'AWAY',
    3: 'UNDER',
    4: 'OVER',
};

export const BET_TYPE_MAPPING = {
    0: 'AHDP',
    1: 'OU',
    default: '1x2'
};

export const BET_STATUS_MAPPING = {
    0: 'Voided',
    1: 'Win',
    2: 'Half Win',
    3: 'Lose',
    4: 'Half Lose',
    5: 'Stake Returned'
};

export function makeBetListing(payload) {
  let bets = payload.data.map(bet => makeBet(bet));
  let total = payload.recordsTotal;

  let betListing = new BetListing();
  betListing.bets = bets;
  betListing.total = payload.recordsTotal;

  return betListing;
}

export function makeBet(payload) {
  let bet = new Bet();

  bet.id = payload.id;
  bet.eventDate = formatDate(payload.event_date, 'MM/DD/YYYY');
  bet.selection = +payload.betRequestType;
  bet.handicap = +payload.handicap;
  bet.bet = +payload.bet;
  bet.betOption = payload.betOption;
  bet.odds = formatAmount(payload.odds);
  bet.stake = formatAmount(payload.stake);
  bet.winLoss = formatAmount(payload.winLoss);
  bet.home = payload.home;
  bet.away = payload.away;
  bet.halftimeBet = payload.halftimeBet;
  bet.betType = +payload.betType;
  bet.currentScore = payload.currentScore;
  // Weird returns from api.
  bet.status = +payload.result;
  
  return bet;
}

export class BetListing {
  constructor() {
    this._bets = [];
    this._total = null;
  }

  set bets(bets) {
    this._bets = bets;
  }

  get bets() {
    return this._bets;   
  }

  set total(total) {
    this._total = total;
  }

  get total() {
    return this._total;
  }
}

export class Bet {
  constructor() {
    this._id = null;
    this._eventDate = null;
    this._selection = null;
    this._bet = null;
    this._betOption = null;
    this._odds = null;
    this._stake = null;
    this._winLoss = null;
    this._status = null;
    this._home = null;
    this._away = null;
    this._halftimeBet = null;
    this._betType = null;
    this._currentScore = null;
    this._handicap = null;
  }

  set id(id) {
    this._id = id;      
  }

  get id() {
    return this._id;
  }

  set eventDate(eventDate) {
    this._eventDate = eventDate;
  }

  get eventDate() {
    return this._eventDate;
  }

  set selection(selection) {
    this._selection = selection;
  }

  get selection() {
    return this._selection;
  }

  set bet(bet) {
    this._bet = bet;
  }

  get bet() {
    return this._bet;
  }

  set betOption(betOption) {
    this._betOption = betOption;
  }

  get betOption() {
    return this._betOption;
  }

  get selectionAsText() {
    let type = '';
    if (this.selection === 0) {
      switch (this.bet) {
      case 0:
        type = 'DRAW ';
        break;
      case 1:
        type = 'HOME ';
        break;
      case 2:
        type = 'AWAY ';
        break;
      case 3:
        type = 'UNDER ';
        break;
      case 4:
        type = 'OVER ';
        break;
      }

      type = type + this.selectionHandicap();
    };

    let betOption = angular.fromJson(this.betOption);

    if (this.selection === 1) {
      type = betOption.special;
    }

    return type;
  }

  set odds(odds) {
    this._odds = odds;
  }

  get odds() {
    return this._odds;
  }

  set stake(stake) {
    this._stake = stake;
  }

  get stake() {
    return this._stake;
  }

  set winLoss(winLoss) {
    this._winLoss = winLoss;
  }

  get winLoss() {
    return this._winLoss;
  }

  set status(status) {
    this._status = status;
  }

  get status() {
    return this._status;
  }

  get statusAsText() {
    return BET_STATUS_MAPPING[this.status];
  }

  set home(home) {
    this._home = home;
  }

  get home() {
    return this._home;
  }

  set away(away) {
    this._away = away;
  }

  get away() {
    return this._away;
  }

  set halftimeBet(halftimeBet) {
    this._halftimeBet = halftimeBet;
  }

  get halfTimeBet() {
    return this._halftimeBet;
  }

  get halfFullTime() {
    return (!this._halftimeBet ? 'FT' : 'HT');
  }
  
  set betType(betType) {
    this._betType = betType;
  }

  get betType() {
    return this._betType;
  }

  get betTypeAsText() {
    return BET_TYPE_MAPPING[this._betType] || BET_TYPE_MAPPING['default'];
  }

  set currentScore(currentScore) {
    this._currentScore = currentScore;
  }

  get currentScore() {
    return this._currentScore;
  }

  set handicap(handicap) {
    this._handicap = handicap;
  }

  get handicap() {
    return this._handicap;
  }

  selectionHandicap() {
    return (0 > this.betType ? '' : formatAmount(this.handicap));
  }

  get details() {   
    switch (this.selection) {
      case 0:
        let texta = `${this.halfFullTime}/${this.betTypeAsText}:`;
        let textb = ` ${this.home} VS ${this.away} ${this.currentScore}`;

        return `${texta}${textb}`;
      case 1:
        return `${this.home} VS ${this.away}`;
      default:
        return this.away;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/api/models/bet.model.js